<mat-dialog-content class="place-cameraContent">
  <div class="placeCameraContainer" cdkDropListGroup>
    <ng-container *ngIf="!isLoadingCameras">
      <div class="leftside">
        <sn-searchbar
          (valueChange)="onSearchValueChange($event)"
          (search)="onSearchValueChange($event)"
          [placeholder]="'Search cameras'"
          [clearOnNavEnd]="false"
          [ariaAutoComplete]="cameraSearched"
          [(value)]="cameraSearched"
        ></sn-searchbar>

        <ng-container *ngIf="this.activeFloor">
          <span class="selectedFloor">{{ activeFloor.name }}</span>
        </ng-container>

        <ng-container *ngIf="!this.activeFloor">
          <span class="selectedFloor">Unassigned Cameras</span>
        </ng-container>

        <mat-list class="cameraGrid" id="camerasList" cdkDropList>
          <ng-container *ngFor="let camera of cameras">
            <div
              cdkDrag
              class="cameraContainer"
              [id]="camera.id"
              (click)="setMultiselect(camera.id)"
            >
              <div class="cameraName">{{ camera.name }}</div>
              <ng-container *ngIf="camera.cameraMeta?.thumbnail">
                <video class="thumbnail" [src]="camera.cameraMeta?.thumbnail"></video>
              </ng-container>
              <ng-container *ngIf="!camera.cameraMeta?.thumbnail"
                ><div class="noThumbnail">No Thumbnail</div></ng-container
              >
              <div class="cameraDisposition">
                <mat-slide-toggle
                  (change)="toggleDispositionType($event, camera)"
                  [checked]="camera.disposition.includes('Internal')"
                >
                  {{ camera.disposition }}
                </mat-slide-toggle>
              </div>
            </div>
          </ng-container>
        </mat-list>
      </div>
    </ng-container>
    <ng-container *ngIf="isLoadingCameras">
      <mat-progress-spinner
        color="accent"
        diameter="48"
        mode="indeterminate"
      ></mat-progress-spinner>
    </ng-container>

    <div class="rightside" id="floorsList">
      <mat-list
        class="list"
        id="unassigned"
        cdkDropList
        (cdkDropListDropped)="dragReleased($event)"
      >
        <mat-list-item class="listItem" (click)="setFloor()">Unassigned (All Floors)</mat-list-item>
      </mat-list>
      <ng-container *ngFor="let floor of location?.floors">
        <mat-list
          class="list"
          [id]="floor.id"
          cdkDropList
          (cdkDropListDropped)="dragReleased($event)"
        >
          <mat-list-item class="listItem" (click)="setFloor(floor)">{{ floor.name }}</mat-list-item>
        </mat-list>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" (click)="close()">CANCEL</button>
</mat-dialog-actions>
